import * as React from 'react'
import { NextPageContext } from 'next'
import { extendInitialProps } from '../utils'
import { SnackbarContent, Snackbar, Icon, IconButton } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

const { Provider, Consumer } = React.createContext({
  message: null,
  sendMessage: null,
})

const StyledSnackbar = styled(SnackbarContent)(({ type }: { type: string }) => {
  const color = {
    info: '#FFF',
    error: 'red',
  }

  return {
    fontSize: 14,
    color: color[type],
  }
})

type Props = {
  message: string | null
  type: string
}

const withMessage = Component => {
  class MessageHoc extends React.PureComponent<Props> {
    static getInitialProps: (props: NextPageContext) => any
    state = {
      message: null,
      type: 'info',
    }

    sendMessage = (message, type = 'info') => {
      this.setState({ message, type })
    }

    render() {
      const { message, type } = this.state
      const sendMessage = this.sendMessage

      return (
        <Provider value={{ message, sendMessage }}>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={!!message}
            // autoHideDuration={4000}
            onClose={() => sendMessage(null)}
          >
            <StyledSnackbar
              message={message}
              type={type}
              action={
                <IconButton onClick={() => sendMessage(null)}>
                  <Icon>close</Icon>
                </IconButton>
              }
            />
          </Snackbar>
          <Consumer>
            {({ sendMessage, message }) => {
              return (
                <Component
                  {...this.props}
                  sendMessage={sendMessage}
                  message={message}
                />
              )
            }}
          </Consumer>
        </Provider>
      )
    }
  }

  MessageHoc.getInitialProps = extendInitialProps(Component)

  return MessageHoc
}

export default withMessage
